import { render, staticRenderFns } from "./PayoutBalanceComponent.vue?vue&type=template&id=481bdcc9"
import script from "./PayoutBalanceComponent.vue?vue&type=script&lang=js"
export * from "./PayoutBalanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports